import React, { Component } from "react";
import {
  Container,
  Card,
  CardHeader,
  Button,
  CardBody,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";

import { connect } from "react-redux";
import FiltertRightbar from "../FiltersRightbar";
import TimeLineLogRightbar from "../TimeLineLogRightbar";

import AllMaterial from "./AllMaterial";
import {
  SetParams,
  getDetMeterialReqList,
  // getDeptMRListcount,
  FiltersShowRightSidebar,
  FilterClear,
} from "../../../store/MaterialRequest/actions";

import "../../../assets/scss/dashboard.scss";
import LoadingModel from "../../LoadingModel";

class DeptMaterialRequest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      currentPage: 1,
      FilterToggle: false,
    };
    // this.toggleTab = this.toggleTab.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  getMRlist(tab) {
    // var mrstatus = [0];
    // if (tab === 1) {
    //   mrstatus = [0];
    // } else if (tab !== 2) {
    //   if (tab === 3) {
    //     mrstatus = [3, 5, 7, 8];
    //   } else if (tab === 4) {
    //     mrstatus = [4, 6];
    //   }
    // } else if (tab === 2) {
    //   mrstatus = [1, 2];
    // }
    this.setState({ activeTab: tab });
    var mrstatus = [0];
    var pistatus = [0];
    var mistatus = [0];
    if (tab === 1) {
      // All
      mrstatus = [0];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 2) {
      // MR Pending
      mrstatus = [1, 2];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 3) {
      // MR Approved
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 4) {
      // MR Rejected
      mrstatus = [4, 6];
      pistatus = [0];
      mistatus = [0];
    } else if (tab === 5) {
      //  PI Pending
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [1, 2];
      mistatus = [0];
    } else if (tab === 6) {
      // PI Completed
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [3];
      mistatus = [0]; //1,2,3
    } else if (tab === 7) {
      // MI Pending
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [1, 2, 3];
    } else if (tab === 8) {
      //  MI Completed
      mrstatus = [3, 5, 9, 10, 11, 12];
      pistatus = [0];
      mistatus = [4];
    }else if (tab === 9) {
      //  MI Completed
      mrstatus = [0];
      pistatus = [0];
      mistatus = [5];
    }
    this.props.SetParams({
      ...this.props.params,
      mrstatus: mrstatus,
      pistatus: pistatus,
      mistatus: mistatus,
      page: 1,
    });
    this.props.getDetMeterialReqList({
      ...this.props.params,
      mrstatus: mrstatus,
      pistatus: pistatus,
      mistatus: mistatus,
      page: 1,
    });
  }
  componentDidMount() {
    this.setState({ activeTab: 1 });
    this.props.FilterClear();

    // this.props.getDeptMRListcount();
    this.props.SetParams({
      ...this.props.params,
      mrstatus: [0],
      pistatus: [0],
      mistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
      location:"",
      mritems__product:"",
    });
    this.props.getDetMeterialReqList({
      ...this.props.params,
      mrstatus: [0],
      pistatus: [0],
      mistatus: [0],
      search: "",
      start_date: "",
      end_date: "",
      userdepartment: "",
      departments: "",
      location:"",
      mritems__product:"",
    });
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content ">
          <Container fluid>
            {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}

            <Row>
              <Col lg={12}>
                <Card className="pagebody">
                  <CardHeader className="bg-transparent pb-0">
                    <div className="d-inline-block">
                      <h5 className="card-title-18 pt-2 d-flex">
                        <span className="d-none d-lg-block">
                          Material Request
                        </span>
                        <span className="d-lg-none">MR</span>
                        <span className="pl-1"> Dashboard</span>
                      </h5>
                    </div>
                    <div className="float-right d-inline-block">
                      <div className="d-inline-block">
                        <Dropdown
                          isOpen={this.state.dropdownOpen}
                          toggle={this.toggle}
                          className="d-flex mr-2"
                        >
                          <DropdownToggle
                            caret
                            color="primary"
                            className="d-flex mr-2"
                          >
                            <i className="mdi mdi-rotate-right"></i>
                            <span className="d-none d-lg-block ml-1">
                              MR List
                            </span>
                          </DropdownToggle>
                          <DropdownMenu>
                            {/* <DropdownItem header>All</DropdownItem> */}
                            <DropdownItem onClick={() => this.getMRlist(1)}>
                              All
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(2)}>
                              MR Pending
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(3)}>
                              MR Approved
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(4)}>
                              MR Rejected
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(5)}>
                              PI Process
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(6)}>
                              PI Completed
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={() => this.getMRlist(7)}>
                              MI Process
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(8)}>
                              MI Completed
                            </DropdownItem>
                            <DropdownItem onClick={() => this.getMRlist(9)}>
                              MI Closed
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex mr-2"
                          onClick={() => {
                            this.setState({ activeTab: 1 });
                            this.props.getDetMeterialReqList({
                              ...this.props.params,
                              mrstatus: [0],
                              search: "",
                              start_date: "",
                              end_date: "",
                              userdepartment: "",
                              departments: "",
                            });
                            this.props.SetParams({
                              ...this.props.params,
                              mrstatus: [0],
                              search: "",
                              start_date: "",
                              end_date: "",
                              userdepartment: "",
                              departments: "",
                            });
                          }}
                        >
                          <i className="mdi mdi-rotate-right"></i>
                          <span className="d-none d-lg-block ml-1">
                            Refresh
                          </span>
                        </Button>
                      </div>
                      <div className="d-inline-block">
                        <Button
                          type="button"
                          color="light"
                          className="waves-effect waves-light d-flex  mr-2"
                          onClick={() => this.props.FiltersShowRightSidebar(2)}
                        >
                          <i className="mdi mdi-filter"></i>
                          <span className="d-none d-lg-block ml-1">
                            Filters
                          </span>
                        </Button>
                      </div>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-0">
                    <Nav tabs className="nav-tabs-custom ">
                      <NavItem>
                        <NavLink
                          className={classnames(
                            { active: true },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          {this.state.activeTab === 1
                            ? "All "
                            : this.state.activeTab === 2
                            ? "Pending "
                            : this.state.activeTab === 3
                            ? "Approved "
                            : this.state.activeTab === 4
                            ? "Rejected "
                            : this.state.activeTab === 5
                            ? "PI Process "
                            : this.state.activeTab === 6
                            ? "PI Completed "
                            : this.state.activeTab === 7
                            ? "MI Process "
                            : this.state.activeTab === 8
                            ? "MI Completed "
                            : ""}
                          | <span>{this.props.mrRowlistcount} </span>
                        </NavLink>
                      </NavItem>
                      {/* <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(2);
                          }}
                          className={classnames(
                            { active: this.props.params.mrstatus[0] === 1 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Pending |{" "}
                          <span>{this.props.mrListCount?.pending_count}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(3);
                          }}
                          className={classnames(
                            { active: this.props.params.mrstatus[0] === 3 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Approved |{" "}
                          <span>{this.props.mrListCount?.approved_count}</span>
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          onClick={() => {
                            this.toggleTab(4);
                          }}
                          className={classnames(
                            { active: this.props.params.mrstatus[0] === 4 },
                            "pt-3 font-weight-bold card-title-16"
                          )}
                        >
                          Rejected |{" "}
                          <span>{this.props.mrListCount?.rejected_count}</span>
                        </NavLink>
                      </NavItem> */}
                    </Nav>
                    <TabContent>
                      <AllMaterial activeTab={this.state.activeTab} />
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <TimeLineLogRightbar />
            <FiltertRightbar />
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { mrRowList, mrRowlistcount, params, loading } = state.Materialrequest;
  return {
    mrRowList,
    mrRowlistcount,
    params,
    loading,
  };
};

export default connect(mapStatetoProps, {
  SetParams,
  getDetMeterialReqList,
  // getDeptMRListcount,
  FiltersShowRightSidebar,
  FilterClear,
})(DeptMaterialRequest);
